import LocalizedStrings from 'localized-strings';

const locales = new LocalizedStrings({
  en: {
    begin: 'Start',
    next: 'Next',
    slides: {
      0: {
        text: 'Set aside money, plan your expenses and contributions, allocate budgets according to your expense items...',
        title: 'Organise your cash flow for better clarity',
      },
      1: {
        text: 'Transfer money between your wallets at any time, simply, instantly and free of charge.',
        title: 'Stay flexible',
      },
      2: {
        text: 'Pay directly by transfer or set up SEPA direct debits from any wallet.',
        title: 'Create separate wallets with dedicated IBANs',
      },
    },
  },
  fr: {
    begin: 'Commencer',
    next: 'Suivant',
    slides: {
      0: {
        text: 'Mettez de côté, anticipez vos charges et vos cotisations, allouez des budgets selon vos postes de dépenses...',
        title: 'Organisez votre trésorerie pour y voir plus clair',
      },
      1: {
        text: 'Transférez de l’argent entre vos comptes à tout moment, simplement, gratuitement et instantanément.',
        title: 'Gérez tous vos comptes avec flexibilité',
      },
      2: {
        text: 'Payez directement par virement ou mettez en place des prélèvements SEPA depuis chaque compte.',
        title: 'Créez des comptes indépendants avec des IBAN dédiés',
      },
    },
  },
} as const);

export default locales;
